import React, { useState, useEffect } from 'react';
import * as request from "../admin/lib/lib";

export function Areas() {
    const [areasData, setAreasData] = useState([]);

    useEffect(() => {
        const populateAreas = async () => {
            try {
                const response = await request.get(process.env.REACT_APP_BACKEND_URL + 'GetInfo/Areas');
                //const jsonData = await response.json();

                setAreasData(response);
                //setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        populateAreas();
        document.title = `Райони`;
    }, []); // The empty dependency array means this effect runs once, equivalent to componentDidMount.

    const Table = ({ data }) => {
        return (
            <table className="table table-bordered  table-responsive-stack mt-5">
                <thead className="color-bg-cl">
                    <tr>
                        <th className="text-rajon">УЧИЛИЩЕ</th>
                        <th className="text-rajon">РАЙОН</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item) => (
                        <tr key={item.id_areas} >
                            <td className="p-2">{item.name}</td>
                            <td className="p-2"><a href={`documents/areas/${item.link}`} className="text_link" target="_blank" rel="noopener noreferrer">Преглед</a></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (

        <div className="cust_table">
            <div className="title_news">Райони</div>
            <div className="col-8 mx-auto m-news-mob w-100-mob">
                <Table data={areasData} />
            </div>
            
        </div>
    );
}

export default Areas;